module.exports = __webpack_public_path__ + "img/cow.f18db282.png";